/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Observable } from 'rxjs';
import { Undefinable } from '../types';

export const useObservable = <T>(observable: Observable<T>, onError?: (error: Error) => unknown): Undefinable<T> => {
  const [state, setState] = useState<T>();

  useEffect(() => {
    let isMounted = true;
    const sub = observable.subscribe({
      next: (data) => {
        if (isMounted) {
          setState(data);
        }
      },
      error: (error: Error) => {
        if (isMounted) {
          onError?.(error);
        }
      },
    });

    return () => {
      isMounted = false;
      sub.unsubscribe();
    };
  }, [observable]);

  return state;
};
